<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="center"><a id="pix"></a> I would like to thank<br/>
Lisa Bankoff and Dawn Seferian<br/>
for their assistance<br/>
and support.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?518a755c